import { QueryClient } from '@tanstack/react-query'
import { onSignedIn, onSignedOut } from '@/lib/appEvents'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: import.meta.env.DEV ? false : 'always',
    },
  },
})

onSignedIn('apiQueryClient', () => queryClient.clear())
onSignedOut('apiQueryClient', () => queryClient.clear())

if (import.meta.env.DEV) {
  const __dev = ((window as any).__dev ||= {})
  __dev.queryClient = queryClient
}
